export default class Utils {
    public static toggle($el: JQuery, visible: boolean, force?: boolean): void {
        if (force) {
            if (visible) {
                $el.show();
            } else {
                $el.hide();
            }
        } else {
            if (visible) {
                $el.slideDown();
            } else {
                $el.slideUp();
            }
        }
    }

    public static getHashParts(): Map<string, string> {
        const map = new Map<string, string>();

        if (window.location.hash) {
            const parts = window.location.hash.substring(1).split('&');

            for (const part of parts) {
                const kv = part.split('=');

                if (kv.length == 2) {
                    map.set(kv[0], kv[1]);
                } else {
                    map.set(kv[0], '');
                }
            }
        }

        return map;
    }
}
